import { css } from 'styled-components';

import { StyledPlaceHolderItem, StyledRow1, StyledRow2, StyledRow3, StyledRow4 } from './PlaceHolder.styles';
import { playGrey10 } from '../design-tokens';
import { device } from '../breakpoints';

export const getLetterGridLayout = () => css`
    margin-top: 30px;

    ${StyledPlaceHolderItem} {
        width: 100%;
        margin-bottom: 10px;
        display: none;

        ${StyledRow1} {
            width: 30px;
            height: 30px;
            padding-bottom: 0;
            margin-bottom: 25px;
            background-color: ${playGrey10};
            animation: none;
        }

        ${StyledRow2} {
            width: 100%;
            margin-bottom: 25px;
            background-color: ${playGrey10};
        }

        ${StyledRow3} {
            width: 100%;
            margin-bottom: 25px;
        }

        ${StyledRow4} {
            display: block;
            width: 100%;
            margin-bottom: 25px;
        }

        &:nth-child(-n + 2) {
            display: block;
        }

        @media ${device.GteSmall} {
            display: block;
            width: 49%;

            &:nth-child(even) ${StyledPlaceHolderItem} {
                ${StyledRow1} {
                    visibility: hidden;
                }
            }
        }

        @media ${device.GteMedium} {
            width: 28%;

            &:nth-child(even) ${StyledPlaceHolderItem} {
                ${StyledRow1} {
                    visibility: visible;
                }
            }

            &:nth-child(2) ${StyledPlaceHolderItem} {
                ${StyledRow1} {
                    visibility: hidden;
                }
            }
            &:nth-child(3) ${StyledPlaceHolderItem} {
                ${StyledRow1} {
                    visibility: hidden;
                }
            }
            &:nth-child(5) ${StyledPlaceHolderItem} {
                ${StyledRow1} {
                    visibility: hidden;
                }
            }
            &:nth-child(6) ${StyledPlaceHolderItem} {
                ${StyledRow1} {
                    visibility: hidden;
                }
            }
        }
    }
`;
